import { render, staticRenderFns } from "./NumberOfStudents.vue?vue&type=template&id=af843070&"
import script from "./NumberOfStudents.vue?vue&type=script&lang=js&"
export * from "./NumberOfStudents.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfStudents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports